import { Question } from '../types';
import { QuizItem } from '@/store/assessment-store';

export interface AnswerHandlers {
  handleMultipleChoice: (option: string, isChecked: boolean) => void;
  handleSingleChoice: (option: string) => void;
  handleTrueFalse: (option: string) => void;
}

interface UseAnswerHandlersProps {
  question: Question;
  questionIndex: number;
  quiz: QuizItem[];
  learningPathwayUID: string;
  setQuizData: (uid: string, data: QuizItem[]) => void;
}

export function useAnswerHandlers({
  question,
  questionIndex,
  quiz,
  learningPathwayUID,
  setQuizData,
}: UseAnswerHandlersProps): AnswerHandlers {
  // Ensure quiz is always an array
  const quizArray = Array.isArray(quiz) ? quiz : [];

  const handleMultipleChoice = (option: string, isChecked: boolean) => {
    const currentQuiz = quizArray.find((q) => q.qindex === questionIndex);
    const currentOptions = currentQuiz?.selected_options || [];

    const updatedOptions = isChecked
      ? [...(Array.isArray(currentOptions) ? currentOptions : []), option]
      : (Array.isArray(currentOptions) ? currentOptions : []).filter(
          (opt: string) => opt !== option
        );

    if (updatedOptions.length === 0) {
      setQuizData(
        learningPathwayUID,
        quizArray.filter((q) => q.qindex !== questionIndex)
      );
    } else {
      setQuizData(learningPathwayUID, [
        ...quizArray.filter((q) => q.qindex !== questionIndex),
        {
          question_uid: question.metadata_uid,
          selected_options: updatedOptions,
          qindex: questionIndex,
          isSubmitted: false,
        },
      ]);
    }
  };

  const handleSingleChoice = (option: string) => {
    if (option) {
      setQuizData(learningPathwayUID, [
        ...quizArray.filter((q) => q.qindex !== questionIndex),
        {
          question_uid: question.metadata_uid,
          selected_options: option,
          qindex: questionIndex,
          isSubmitted: false,
        },
      ]);
    }
  };

  const handleTrueFalse = (option: string) => {
    // Handle both "true" and "false" string values explicitly
    // Note: "false" is a truthy string, so we need to check for both values
    if (option === 'true' || option === 'false') {
      setQuizData(learningPathwayUID, [
        ...quizArray.filter((q) => q.qindex !== questionIndex),
        {
          question_uid: question.metadata_uid,
          selected_options: option === 'true',
          qindex: questionIndex,
          isSubmitted: false,
        },
      ]);
    }
  };

  return {
    handleMultipleChoice,
    handleSingleChoice,
    handleTrueFalse,
  };
}

